/* ---------------------------------------------------------------------------
 * MD Fashionwear — recommendation persistence + scroll position
 *
 * WHY THIS EXISTS
 * Adding an item makes the theme replace the whole cart drawer about 2.8s later,
 * which threw away the recommendation carousel and reset every scroll position.
 * The shopper was thrown back to the top of the drawer and the first card in the
 * carousel, mid-browse.
 *
 * Two things are kept across that re-render:
 *   1. the chosen products, trimmed, so the carousel rebuilds instantly with the
 *      same items instead of blanking and reshuffling
 *   2. where the shopper was — carousel scroll, drawer scroll, page scroll
 *
 * RESTORING IS NOT A ONE-SHOT. A freshly rendered drawer often has no layout for
 * a moment, and you cannot set scrollLeft on an element whose scrollWidth still
 * equals its clientWidth — the assignment silently does nothing. So the restore
 * polls until the track is genuinely scrollable, then applies and stops.
 *
 * Loaded BEFORE md-cart-recs.js and md-cart-hydrate.js, which both use it.
 * ------------------------------------------------------------------------- */

(function () {
  'use strict';

  var KEY = 'md_cart_recs_v1';
  var SKEY = 'md_cart_scroll_v1';
  var TTL = 30 * 60 * 1000;

  function ctx() {
    var cur = (window.Shopify && window.Shopify.currency && window.Shopify.currency.active) || '';
    var country = (window.Shopify && window.Shopify.country) || '';
    return cur + '|' + country;
  }

  function slim(p) {
    return {
      id: p.id,
      title: p.title,
      handle: p.handle,
      product_type: p.product_type,
      options: (p.options || []).map(function (o, i) {
        if (typeof o === 'string') return { name: o, position: i + 1, values: [] };
        return { name: o.name, position: o.position || (i + 1), values: o.values || [] };
      }),
      variants: (p.variants || []).map(function (v) {
        return {
          id: v.id,
          title: v.title,
          option1: v.option1,
          option2: v.option2,
          option3: v.option3,
          available: v.available,
          price: v.price,
          featured_image: (v.featured_image && v.featured_image.src) ? { src: v.featured_image.src } : null
        };
      }),
      images: (p.images || []).map(function (im) {
        if (typeof im === 'string') return { src: im, variant_ids: [] };
        return { src: im.src, variant_ids: im.variant_ids || [] };
      })
    };
  }

  function save(shown, reserve, excluded) {
    try {
      sessionStorage.setItem(KEY, JSON.stringify({
        t: Date.now(),
        ctx: ctx(),
        shown: shown.map(slim),
        reserve: reserve.slice(0, 40).map(slim),
        excluded: excluded || {}
      }));
    } catch (e) {}
  }

  function load() {
    try {
      var o = JSON.parse(sessionStorage.getItem(KEY) || 'null');
      if (!o || o.ctx !== ctx()) return null;
      if (Date.now() - o.t > TTL) return null;
      if (!o.shown || !o.shown.length) return null;
      return o;
    } catch (e) {
      return null;
    }
  }

  function clear() {
    try { sessionStorage.removeItem(KEY); } catch (e) {}
  }

  /* ------------------------------------------------------ scroll position */

  // The drawer's scrolling element is not a fixed class across theme versions,
  // so find the nearest ancestor that actually scrolls.
  function findScroller(node) {
    var el = node;
    while (el && el !== document.documentElement) {
      var cs = window.getComputedStyle(el);
      if ((el.scrollHeight - el.clientHeight) > 4 && /auto|scroll/.test(cs.overflowY)) return el;
      el = el.parentElement;
    }
    return null;
  }

  function saveScroll() {
    try {
      var host = document.getElementById('md-recs');
      var track = host && host.querySelector('.md-recs__track');
      var scroller = host ? findScroller(host) : null;

      sessionStorage.setItem(SKEY, JSON.stringify({
        t: Date.now(),
        left: track ? track.scrollLeft : 0,
        top: scroller ? scroller.scrollTop : 0,
        win: window.scrollY || 0
      }));
    } catch (e) {}
  }

  var restoreTimer = null;

  function restoreScroll() {
    var o;
    try {
      o = JSON.parse(sessionStorage.getItem(SKEY) || 'null');
    } catch (e) {
      return;
    }
    if (!o) return;
    if (Date.now() - o.t > 30000) return;        // stale, the shopper moved on
    if (!o.left && !o.top && !o.win) return;

    if (restoreTimer) { clearInterval(restoreTimer); restoreTimer = null; }

    var tries = 0;

    var attempt = function () {
      tries++;
      var host = document.getElementById('md-recs');
      if (!host) { if (tries > 30) stop(); return; }

      var done = true;

      if (o.left) {
        var track = host.querySelector('.md-recs__track');
        // Assigning scrollLeft does nothing until the track can actually scroll.
        if (track && track.scrollWidth - track.clientWidth > 10) {
          track.scrollLeft = o.left;
          if (Math.abs(track.scrollLeft - o.left) > 40) done = false;
        } else {
          done = false;
        }
      }

      if (o.top) {
        var scroller = findScroller(host);
        if (scroller) scroller.scrollTop = o.top;
        else done = false;
      }

      if (o.win) window.scrollTo(0, o.win);

      if (done || tries > 30) stop();
    };

    var stop = function () {
      if (restoreTimer) { clearInterval(restoreTimer); restoreTimer = null; }
    };

    attempt();
    restoreTimer = setInterval(attempt, 100);    // up to ~3s
  }

  window.MDCartStore = {
    save: save,
    load: load,
    clear: clear,
    slim: slim,
    saveScroll: saveScroll,
    restoreScroll: restoreScroll
  };
})();
